/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfileActivity
 */
export interface StoreProfileActivity {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileActivity
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileActivity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileActivity
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileActivity
     */
    icon: string;
}

/**
 * Check if a given object implements the StoreProfileActivity interface.
 */
export function instanceOfStoreProfileActivity(value: object): value is StoreProfileActivity {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('icon' in value) || value['icon'] === undefined) return false;
    return true;
}

export function StoreProfileActivityFromJSON(json: any): StoreProfileActivity {
    return StoreProfileActivityFromJSONTyped(json, false);
}

export function StoreProfileActivityFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileActivity {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'description': json['description'],
        'icon': json['icon'],
    };
}

export function StoreProfileActivityToJSON(json: any): StoreProfileActivity {
    return StoreProfileActivityToJSONTyped(json, false);
}

export function StoreProfileActivityToJSONTyped(value?: StoreProfileActivity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

